import theme from '#components/Layout/theme';

class OnScrollAnimateBuilder {
  activeStyle = 'active';

  distanceToReveal: number;

  className: string;

  elements: NodeListOf<Element> | null;

  footer = null as Element | null;

  constructor(className: string, distanceToReveal?: number) {
    this.distanceToReveal = distanceToReveal ?? 150;
    this.className = className;
    this.elements = document.querySelectorAll(`.${className}`);
  }

  onScroll = {
    activeStyle: this.activeStyle,
    distanceToReveal: 150,
    className: '',
    elements: null as NodeListOf<Element> | null,
    footer: null as Element | null,
    page: '',
    hasReachedFooter: false,
    windowHeight: window.innerHeight,

    handleEvent() {
      const resetData = () => {
        this.elements = document.querySelectorAll(this.className);
        this.footer = document.querySelector('.footer-main');
        this.hasReachedFooter = false;
        this.page = window.location.pathname;
        this.windowHeight = window.innerHeight;
      };

      if (this.page !== window.location.pathname) {
        resetData();
      }

      if (!this.elements
        || !this.elements.length
        || (this.footer && this.footer.getBoundingClientRect().top < this.windowHeight)) {
        window.removeEventListener('scroll', this, true);
      }

      this.elements?.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;

        if (elementTop < this.windowHeight - this.distanceToReveal) {
          element.classList.add(this.activeStyle);
        }
      });
    },
  };

  applyAnimationToVisibleElements() {
    this.elements?.forEach((element) => {
      const elementTop = element.getBoundingClientRect().top;
      if (elementTop < window.innerHeight - this.distanceToReveal) {
        element.classList.add(this.activeStyle);
      }
    });
  }

  init() {
    const footer = document.querySelector('.footer-main');
    this.onScroll.distanceToReveal = this.distanceToReveal;
    this.onScroll.className = this.className;
    this.onScroll.elements = this.elements;
    this.onScroll.footer = footer;
    this.onScroll.page = window.location.pathname;
    this.applyAnimationToVisibleElements();

    this.elements && this.elements.length
      ? window.addEventListener('scroll', this.onScroll, true)
      : window.removeEventListener('scroll', this.onScroll, true);
  }
}

interface Props {
  className: string;
  distanceToReveal?: number;
}

const onScrollAnimate = {

  /**
   * @param elements An object with the following properties:
   *
   * - className = A string to use as the element selector.
   *  Make sure to prefix the string with a dot for class names
   * and hash tags for id names.
   *
   * - distanceToReveal = This is an optional field.  It accept a number to
   *  indicate how soon to start the animation once
   *  the element is about to be visible in the viewport. The default value is 150.
   *
   */
  register(elements: Props[]) {
    if (elements && elements.length) {
      elements.forEach((element) => {
        const distanceToReveal = window.innerWidth < theme.breakpoints.values.md
          ? 50
          : element.distanceToReveal;

        new OnScrollAnimateBuilder(element.className, distanceToReveal)
          .init();
      });
    }
  },
};

export default onScrollAnimate;
